var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlood1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45849 0.586569C8.33797 0.490076 8.18818 0.4375 8.03379 0.4375C7.8794 0.4375 7.72961 0.490076 7.60909 0.586569C7.35767 0.817605 0.5625 6.29451 0.5625 11.9889C0.5625 13.9713 1.35001 15.8725 2.75179 17.2743C4.15356 18.676 6.05478 19.4636 8.03719 19.4636C10.0196 19.4636 11.9208 18.676 13.3226 17.2743C14.7244 15.8725 15.5119 13.9713 15.5119 11.9889C15.5119 6.29451 8.71671 0.817605 8.45849 0.586569ZM8.03719 18.1045C6.41522 18.1045 4.85967 17.4602 3.71277 16.3133C2.56586 15.1664 1.92153 13.6108 1.92153 11.9889C1.92153 7.70791 6.58982 3.28425 8.03719 2.00676C9.48456 3.28425 14.1528 7.70791 14.1528 11.9889C14.1528 13.6108 13.5085 15.1664 12.3616 16.3133C11.2147 17.4602 9.65916 18.1045 8.03719 18.1045Z",
    fill: "#FF6868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03787 15.3896C7.13677 15.3896 6.27258 15.0316 5.63541 14.3945C4.99824 13.7573 4.64028 12.8931 4.64028 11.992C4.64028 11.8118 4.56869 11.639 4.44126 11.5115C4.31382 11.3841 4.14099 11.3125 3.96077 11.3125C3.78055 11.3125 3.60771 11.3841 3.48028 11.5115C3.35284 11.639 3.28125 11.8118 3.28125 11.992C3.28125 13.2536 3.78239 14.4634 4.67443 15.3555C5.56647 16.2475 6.77634 16.7486 8.03787 16.7486C8.21809 16.7486 8.39093 16.677 8.51836 16.5496C8.6458 16.4222 8.71739 16.2493 8.71739 16.0691C8.71739 15.8889 8.6458 15.7161 8.51836 15.5886C8.39093 15.4612 8.21809 15.3896 8.03787 15.3896Z",
    fill: "#FF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood1);
export default __webpack_public_path__ + "static/media/blood1.ed7f1c5c70616c2fb25a4ee89a6dba05.svg";
export { ForwardRef as ReactComponent };